import React, { useState, Suspense } from 'react';
import Tooltip from 'shared/ui/Tooltip';
import Loading from 'shared/ui/Loading';
import SupplierGroupForm from 'features/parties/components/supplier-groups/SupplierGroupForm';
import SupplierGroupsList from 'features/parties/components/supplier-groups/SupplierGroupsList';
import { useLayout } from 'shared/contexts/LayoutContext';
import { useStateContext } from 'shared/contexts/ContextProvider';
import { Info } from 'lucide-react';

const SupplierGroups = () => {
  const { currentColor } = useStateContext();
  const { openModal } = useLayout();

  const handleAddSupplierGroup = () => {
    openModal({
      component: <SupplierGroupForm />,
      title: 'Добавить группу клиентов',
    });
  };

  return (
    <>
      <Suspense fallback={<Loading/>}>
        <div className='bg-gray-100 py-4 px-6 flex justify-between items-center relative'>
          <div className='flex items-center relative'>
            <Tooltip trigger='click' className='mr-2'>
              <button className='text-gray-700 hover:text-gray-900 mr-2 mt-1'>
                <Info size={20} />
              </button>
            </Tooltip>
            <h1 className='text-2xl font-bold'>Группы поставщиков</h1>
          </div>
          <div className='flex items-center'>
            <button className='text-white px-4 py-2 rounded-md hover:' style={{ backgroundColor: currentColor }} onClick={() => handleAddSupplierGroup()}>
              + Группа поставщиков
            </button>
          </div>
        </div>
        
        <SupplierGroupsList/>
      </Suspense>
    </>
  );
};

export default SupplierGroups;
